






































import { Component, Vue, Prop } from "@zoovu/runner-browser-api";
import { ChoiceAnswerView } from "@zoovu/runner-web-design-base";

@Component({
  name: "ChoiceAnswerView",
  mixins: [ChoiceAnswerView]
})
export default class ChoiceAnswerViewExtended extends Vue {
  @Prop()
  hasQuestionCustomWidthAttribute!: boolean;

  get inputWrapperStyle() {
    const textHeight = this.answerTextHeight.endsWith("px")
      ? this.answerTextHeight.slice(0, -2)
      : this.answerTextHeight;
    const verticalPadding = 15 * 2;
    const height = `${parseInt(textHeight, 10) + verticalPadding}px`;
    return {
      height
    };
  }

  get widthOnQueries() {
    return this.hasQuestionCustomWidthAttribute ? "answerFullWidth" : "";
  }

  withOfAnswers() {
    return this.hasQuestionCustomWidthAttribute === true
      ? { width: "100% !important" }
      : { width: `calc(${Math.floor(100 / this.enabledAnswersLength)}% - 15px` };
  }
}
